const colorCodes = {
  AD: "#c6c8cc",
  BD: "#d58858",
  CH: "#a2cfa0",
  CL: "#8b2f21",
  DD: "#FFFFFF",
  GA: "#9b352a",
  LL: "#283387",
  MC: "#344c43",
  PM: "#ddc3b7",
  PS: "#91475f",
  QJ: "#8c6ea0",
  RC: "#f19da4",
  SA: "#263681",
  TE: "#a66122",
  BLUE: "#8c6ea0",
  PINK: "#d7486f",
  GREEN: "#344c43",
  RED: "#8b2f21",
  "18KR": "#d6b084",
  "18KW": "#d7d5d3",
  "18RB": "#c49d7e",
  "18KY": "#f0d989",
  "18WR": "#d8b28d",
  "18WB": "#dddedd",
  SILV: "#cccac9"
};

export default colorCodes;
